import { ReportData } from '../types/reportTypes';

// Parse currency string to number
const parseCurrency = (value: string): number => {
  if (!value || value === '') return 0;
  return parseFloat(value.replace(/[$,]/g, ''));
};

// Parse percentage string to number
const parsePercentage = (value: string): number => {
  if (!value || value === '') return 0;
  return parseFloat(value.replace(/%/g, '')) / 100;
};

// Calculate the sum of an array of numbers
const sum = (numbers: number[]): number => {
  return numbers.reduce((total, num) => total + num, 0);
};

// Calculate the individual job data from the Sales June CSV
const jobData = [
  {
    jobInfo: "E-445: Justin & Jennifer Blanche",
    leadSource: "Yelp",
    trade: "Gutters",
    contractTotal: 3225.00,
    grossMarginPct: 0.6302,
    grossProfit: 2032.40,
    commissionPercentage: 10.00,
    salesCommission: 322.50,
    salesManagerFee: 32.25,
    companyOH: 499.88,
    netProfit: 0
  },
  {
    jobInfo: "E-462: Stacey & Dana Scrivner",
    leadSource: "Previous Customer",
    trade: "Attic Insulation",
    contractTotal: 2872.17,
    grossMarginPct: 0.4691,
    grossProfit: 1347.33,
    commissionPercentage: 4.00,
    salesCommission: 114.89,
    salesManagerFee: 28.72,
    companyOH: 445.19,
    netProfit: 0
  },
  {
    jobInfo: "E-440: Sheri & Doug Elmendorf",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 24468.05,
    grossMarginPct: 0.4285,
    grossProfit: 10484.56,
    commissionPercentage: 4.00,
    salesCommission: 978.72,
    salesManagerFee: 244.68,
    companyOH: 3792.55,
    netProfit: 0
  },
  {
    jobInfo: "E-430: Tonya Bright",
    leadSource: "Angi",
    trade: "Roofing",
    contractTotal: 10507.75,
    grossMarginPct: 0.4344,
    grossProfit: 4564.57,
    commissionPercentage: 4.00,
    salesCommission: 420.31,
    salesManagerFee: 105.08,
    companyOH: 1628.70,
    netProfit: 0
  },
  {
    jobInfo: "E-444: Greg & Christine cook",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 7122.00,
    grossMarginPct: 0.5020,
    grossProfit: 3575.24,
    commissionPercentage: 7.00,
    salesCommission: 498.54,
    salesManagerFee: 71.22,
    companyOH: 1103.91,
    netProfit: 0
  },
  {
    jobInfo: "E-460: April & Michael Austin",
    leadSource: "Thumbtack",
    trade: "Doors & Gutters",
    contractTotal: 6950.00,
    grossMarginPct: 0.4462,
    grossProfit: 3101.09,
    commissionPercentage: 4.00,
    salesCommission: 278.00,
    salesManagerFee: 69.50,
    companyOH: 1077.25,
    netProfit: 0
  },
  {
    jobInfo: "E-447: Rose Kester",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 4272.00,
    grossMarginPct: 0.4085,
    grossProfit: 1745.11,
    commissionPercentage: 4.00,
    salesCommission: 170.88,
    salesManagerFee: 42.72,
    companyOH: 662.16,
    netProfit: 0
  },
  {
    jobInfo: "E-441: Ben & Kristina Yoder",
    leadSource: "Thumbtack",
    trade: "Entry Doors",
    contractTotal: 8185.00,
    grossMarginPct: 0.5059,
    grossProfit: 4140.79,
    commissionPercentage: 7.00,
    salesCommission: 572.95,
    salesManagerFee: 81.85,
    companyOH: 1268.68,
    netProfit: 0
  },
  {
    jobInfo: "E-411: Eric & Lauren Stanculescu",
    leadSource: "Previous Customer",
    trade: "Roofing",
    contractTotal: 8690.00,
    grossMarginPct: 0.4001,
    grossProfit: 3476.87,
    commissionPercentage: 4.00,
    salesCommission: 347.60,
    salesManagerFee: 86.90,
    companyOH: 1346.95,
    netProfit: 0
  },
  {
    jobInfo: "E-437: Jay & Lyn Womack",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 5100.00,
    grossMarginPct: 0.6513,
    grossProfit: 3321.63,
    commissionPercentage: 10.00,
    salesCommission: 510.00,
    salesManagerFee: 51.00,
    companyOH: 790.50,
    netProfit: 0
  },
  {
    jobInfo: "Lyndsay & John (Jay) Davies",
    leadSource: "Google Organic Search",
    trade: "Siding",
    contractTotal: 7237.00,
    grossMarginPct: 0.4000,
    grossProfit: 2894.80,
    commissionPercentage: 4.00,
    salesCommission: 289.48,
    salesManagerFee: 72.37,
    companyOH: 1121.74,
    netProfit: 0
  },
  {
    jobInfo: "Greta & Tom Kessler",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 6721.00,
    grossMarginPct: 0.4000,
    grossProfit: 2688.40,
    commissionPercentage: 4.00,
    salesCommission: 268.84,
    salesManagerFee: 67.21,
    companyOH: 1041.76,
    netProfit: 0
  },
  {
    jobInfo: "Helen Lowe",
    leadSource: "Homebuddy",
    trade: "Windows & Doors",
    contractTotal: 8160.00,
    grossMarginPct: 0.4000,
    grossProfit: 3264.00,
    commissionPercentage: 4.00,
    salesCommission: 326.40,
    salesManagerFee: 81.60,
    companyOH: 1264.80,
    netProfit: 0
  },
  {
    jobInfo: "Mark & Christina Newcomer",
    leadSource: "Previous Customer",
    trade: "Windows & Doors",
    contractTotal: 5275.00,
    grossMarginPct: 0.4000,
    grossProfit: 2110.00,
    commissionPercentage: 4.00,
    salesCommission: 211.00,
    salesManagerFee: 52.75,
    companyOH: 817.63,
    netProfit: 0
  },
  {
    jobInfo: "Rosa Mayberry",
    leadSource: "Referral - From past customer",
    trade: "Windows & Doors",
    contractTotal: 8750.00,
    grossMarginPct: 0.4000,
    grossProfit: 3500.00,
    commissionPercentage: 4.00,
    salesCommission: 350.00,
    salesManagerFee: 87.50,
    companyOH: 1356.25,
    netProfit: 0
  },
  {
    jobInfo: "Aundre & Leah Cuffy",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 1758.00,
    grossMarginPct: 0.4000,
    grossProfit: 703.20,
    commissionPercentage: 4.00,
    salesCommission: 70.32,
    salesManagerFee: 17.58,
    companyOH: 272.49,
    netProfit: 0
  },
  {
    jobInfo: "NAOMI Mitchell",
    leadSource: "Homebuddy",
    trade: "Windows & Doors",
    contractTotal: 7221.00,
    grossMarginPct: 0.4000,
    grossProfit: 2888.40,
    commissionPercentage: 4.00,
    salesCommission: 288.84,
    salesManagerFee: 72.21,
    companyOH: 1119.26,
    netProfit: 0
  },
  {
    jobInfo: "E-442: Hallie & Jarid Persell",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 3190.56,
    grossMarginPct: 0.5748,
    grossProfit: 1833.93,
    commissionPercentage: 7.00,
    salesCommission: 223.34,
    salesManagerFee: 31.91,
    companyOH: 494.54,
    netProfit: 0
  },
  {
    jobInfo: "E-434: Maisha Barnes",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 8049.71,
    grossMarginPct: 0.5047,
    grossProfit: 4062.69,
    commissionPercentage: 7.00,
    salesCommission: 563.48,
    salesManagerFee: 80.50,
    companyOH: 1247.71,
    netProfit: 0
  },
  {
    jobInfo: "E-429: Kate & Rylan Foster",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 3722.00,
    grossMarginPct: 0.6644,
    grossProfit: 2472.90,
    commissionPercentage: 10.00,
    salesCommission: 372.20,
    salesManagerFee: 37.22,
    companyOH: 576.91,
    netProfit: 0
  },
  {
    jobInfo: "E-428: Allette Hannon",
    leadSource: "Yelp",
    trade: "Gutters",
    contractTotal: 5170.75,
    grossMarginPct: 0.5389,
    grossProfit: 2786.52,
    commissionPercentage: 7.00,
    salesCommission: 361.95,
    salesManagerFee: 51.71,
    companyOH: 801.47,
    netProfit: 0
  },
  {
    jobInfo: "E-417: Claire Gowen",
    leadSource: "Thumbtack",
    trade: "Gutters",
    contractTotal: 5826.00,
    grossMarginPct: 0.6909,
    grossProfit: 4025.18,
    commissionPercentage: 10.00,
    salesCommission: 582.60,
    salesManagerFee: 58.26,
    companyOH: 903.03,
    netProfit: 0
  },
  {
    jobInfo: "E-414: Karin Porter",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 4320.00,
    grossMarginPct: 0.7155,
    grossProfit: 3090.96,
    commissionPercentage: 10.00,
    salesCommission: 432.00,
    salesManagerFee: 43.20,
    companyOH: 669.60,
    netProfit: 0
  },
  {
    jobInfo: "E-452: Bridget & Anthony Taylor",
    leadSource: "Referral - From past customer",
    trade: "Roofing",
    contractTotal: 9478.40,
    grossMarginPct: 0.4229,
    grossProfit: 4008.42,
    commissionPercentage: 4.00,
    salesCommission: 379.14,
    salesManagerFee: 94.78,
    companyOH: 1469.15,
    netProfit: 0
  },
  {
    jobInfo: "E-422: Mark McKitrick",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 9373.00,
    grossMarginPct: 0.4650,
    grossProfit: 4358.45,
    commissionPercentage: 4.00,
    salesCommission: 374.92,
    salesManagerFee: 93.73,
    companyOH: 1452.82,
    netProfit: 0
  },
  {
    jobInfo: "E-455: Valerie Goodman",
    leadSource: "Homebuddy",
    trade: "Windows & Doors",
    contractTotal: 24528.00,
    grossMarginPct: 0.4351,
    grossProfit: 10672.13,
    commissionPercentage: 4.00,
    salesCommission: 981.12,
    salesManagerFee: 245.28,
    companyOH: 3801.84,
    netProfit: 0
  },
  {
    jobInfo: "E-435: Nolan & Ruth Barco",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 9300.30,
    grossMarginPct: 0.4508,
    grossProfit: 4192.58,
    commissionPercentage: 4.00,
    salesCommission: 372.01,
    salesManagerFee: 93.00,
    companyOH: 1441.55,
    netProfit: 0
  },
  {
    jobInfo: "William & Lateefah Hughes",
    leadSource: "Facebook / Meta Ads",
    trade: "Roofing",
    contractTotal: 83500.00,
    grossMarginPct: 0.4000,
    grossProfit: 33400.00,
    commissionPercentage: 4.00,
    salesCommission: 3340.00,
    salesManagerFee: 835.00,
    companyOH: 12942.50,
    netProfit: 0
  }
];

// Apply standard calculation formula: Net Profit = Gross Profit - (Sales Commission + Sales Manager Fee + Company OH)
jobData.forEach(job => {
  job.netProfit = job.grossProfit - (job.salesCommission + job.salesManagerFee + job.companyOH);
});

// Calculate totals
const totalContractValue = sum(jobData.map(job => job.contractTotal));
const totalGrossProfit = sum(jobData.map(job => job.grossProfit));
const totalSalesCommissions = sum(jobData.map(job => job.salesCommission));
const totalManagerFees = sum(jobData.map(job => job.salesManagerFee));
const totalCompanyOH = sum(jobData.map(job => job.companyOH));
const totalNetProfitBeforeAdSpend = sum(jobData.map(job => job.netProfit));

// Ad spend data from June AdSpend CSV
const adSpendData = [
  { source: "Google Organic", spend: 3500.00 },
  { source: "Porch", spend: 287.16 },
  { source: "Guild Quality", spend: 0.00 },
  { source: "Networx", spend: 1680.00 },
  { source: "Contractor Appointment", spend: 0.00 },
  { source: "HomeBuddy", spend: 8908.00 },
  { source: "Thumbtack", spend: 14100.00 },
  { source: "Web to Lead Form (Roofing Calculator)", spend: 9975.00 },
  { source: "Yelp", spend: 4680.00 },
  { source: "Google AdWords", spend: 651.60 },
  { source: "Google LSA", spend: 680.00 },
  { source: "BBB", spend: 300.00 },
  { source: "Lead2Performance", spend: 0.00 },
  { source: "Spring Connect", spend: 0.00 },
  { source: "Facebook / Meta Ads", spend: 5690.70 },
  { source: "Angi", spend: 2530.00 }
];

const totalAdSpend = sum(adSpendData.map(item => item.spend));

// Calculate final net profit after ad spend
const totalNetProfit = totalNetProfitBeforeAdSpend - totalAdSpend;

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap).sort((a, b) => b.totalSales - a.totalSales);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap).sort((a, b) => b.totalSales - a.totalSales);

// Export the June 2025 report data
export const juneData: ReportData = {
  kpis: {
    adSpend: totalAdSpend,
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: totalManagerFees,
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit,
    netProfitPercent: totalNetProfit / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },
  adSpendBySource: adSpendData.filter(item => item.spend > 0),
  salesBySource: salesBySource,
  salesByTrade: salesByTrade,
  jobData: jobData,
  period: {
    month: 6, // June
    year: 2025
  }
};